<script setup lang="ts">
import type { SnackbarType } from '~/stores/snackbar'

withDefaults(defineProps<{
  message: string
  show: boolean
  type?: SnackbarType
}>(), {
  type: 'success'
})
</script>

<template>
  <Transition
    enter-active-class="transform ease-out duration-300 transition"
    enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
    enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
    leave-active-class="transition ease-in duration-100"
    leave-from-class="opacity-100"
    leave-to-class="opacity-0"
  >
    <div
      v-if="show"
      class="fixed right-4 top-4 z-[9999] rounded-md p-4 shadow-lg"
      :class="type === 'error' ? 'bg-red-500' : 'bg-green-500'"
    >
      <div class="flex items-center">
        <div class="shrink-0">
          <svg v-if="type === 'error'" class="size-12 text-white" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
          </svg>
          <svg v-else class="size-12 text-white" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
          </svg>
        </div>
        <div class="ml-3 mt-4">
          <p class="text-xl font-medium !text-white">
            {{ message }}
          </p>
        </div>
      </div>
    </div>
  </Transition>
</template>
